import { GET_ALLUNIT_API, GET_PROJECT_LIST } from '../api/MaterialApi'
import { SetLocalStorage, isResponseCodeSuccess } from '../tools/util'

export const SelectStorageKeyList = [
  'SEL_PLATFORM',
  'SEL_UNIT',
  'SEL_SRMPLATFORM',
] as const

export type SelectStorageKey = (typeof SelectStorageKeyList)[number]

const strategies: { [x in SelectStorageKey]: () => Promise<any> } = {
  async SEL_PLATFORM() {
    const res = await GET_PROJECT_LIST()
    if (isResponseCodeSuccess(res.code)) {
      return (
        res.data?.map((item) => {
          return {
            name: item.platformName,
            id: item.platformCode,
            code: item.platformCode,
          }
        }) ?? []
      )
    }
    return []
  },
  async SEL_UNIT() {
    const res = await GET_ALLUNIT_API()
    if (isResponseCodeSuccess(res.code)) {
      return (
        res?.data?.map((item: any) => ({
          name: item.name,
          id: item.unit,
          code: item.unit,
        })) ?? []
      )
    }
    return []
  },
  async SEL_SRMPLATFORM() {
    const res = await GET_PROJECT_LIST()
    if (isResponseCodeSuccess(res.code)) {
      return (
        res?.data?.map((item) => ({
          name: item.platformName,
          id: item.platformName,
          code: item.platformName,
        })) ?? []
      )
    }
    return []
  },
}

async function SetSelectStorage(key: SelectStorageKey) {
  const res = await strategies[key]()
  SetLocalStorage(key, res)
}
/**
 * 加载筛选列表的选择框项目
 */
export async function LoadSelectData() {
  for (const key of SelectStorageKeyList) {
    SetSelectStorage(key)
  }
}
import { GET_ALLUNIT_API, GET_PROJECT_LIST } from '../api/MaterialApi'
import { SetLocalStorage, isResponseCodeSuccess } from '../tools/util'

export const SelectStorageKeyList = [
  'SEL_PLATFORM',
  'SEL_UNIT',
  'SEL_SRMPLATFORM',
] as const

export type SelectStorageKey = (typeof SelectStorageKeyList)[number]

const strategies: { [x in SelectStorageKey]: () => Promise<any> } = {
  async SEL_PLATFORM() {
    const res = await GET_PROJECT_LIST()
    if (isResponseCodeSuccess(res.code)) {
      return (
        res.data?.map((item) => {
          return {
            name: item.platformName,
            id: item.platformCode,
            code: item.platformCode,
          }
        }) ?? []
      )
    }
    return []
  },
  async SEL_UNIT() {
    const res = await GET_ALLUNIT_API()
    if (isResponseCodeSuccess(res.code)) {
      return (
        res?.data?.map((item: any) => ({
          name: item.name,
          id: item.unit,
          code: item.unit,
        })) ?? []
      )
    }
    return []
  },
  async SEL_SRMPLATFORM() {
    const res = await GET_PROJECT_LIST()
    if (isResponseCodeSuccess(res.code)) {
      return (
        res?.data?.map((item) => ({
          name: item.platformName,
          id: item.platformName,
          code: item.platformName,
        })) ?? []
      )
    }
    return []
  },
}

async function SetSelectStorage(key: SelectStorageKey) {
  const res = await strategies[key]()
  SetLocalStorage(key, res)
}
/**
 * 加载筛选列表的选择框项目
 */
export async function LoadSelectData() {
  for (const key of SelectStorageKeyList) {
    SetSelectStorage(key)
  }
}
